import type { ComponentPropsWithoutRef, FunctionComponent, SourceHTMLAttributes } from 'react';

export interface ImageProps extends ComponentPropsWithoutRef<'img'> {
  lazyLoad?: boolean;
  src: string;
  sources?: SourceHTMLAttributes<HTMLSourceElement>[];
}

export const Image: FunctionComponent<ImageProps> = ({
  alt = '',
  lazyLoad = true,
  sizes,
  sources,
  ...attrs
}) => {
  const loading = lazyLoad ? 'lazy' : 'eager';
  const decoding = lazyLoad ? 'async' : 'auto';
  const Img = <img {...attrs} alt={alt} decoding={decoding} draggable="false" loading={loading} />;

  if (!sources?.length) {
    return Img;
  }

  return (
    <picture>
      {sources.map((source, index) => (
        <source key={index} sizes={sizes} {...source} />
      ))}
      {Img}
    </picture>
  );
};
